import { ReactNode } from 'react';
import { OrderOptionsValues } from '@bandido/shared/enums';

export enum QueryKeys {
  DASHBOARD_CASES_BY_CHANNEL = 'dashboard-cases-by-channel',
  DASHBOARD_CASES_BY_DAY = 'dashboard-cases-by-day',
  DASHBOARD_CASES_BY_HOUR_AND_CHANNEL = 'dashboard-cases-by-hour-and-channel',
  DASHBOARD_CASES_NEED_AGENT_BY_TIME = 'dashboard-cases-need-agent-by-time',
  DASHBOARD_MISSING_AGENT = 'dashboard-missing-agent',
  DASHBOARD_TODAY_CASES = 'dashboard-today-cases',
  getContentExtractorJobs = 'getContentExtractorJobs',
  getTokenOrganizations = 'getTokenOrganizations',
  getAirportsByText = 'getAirportsByText',
  getAllAgencies = 'getAllAgencies',
  getMyAgencies = 'getMyAgencies',
  getAgencyById = 'getAgencyById',
  getAllBookings = 'getAllBookings',
  getAllCases = 'getAllCases',
  getInfinityCases = 'getInfinityCases',
  getAllClients = 'getAllClients',
  getClientByPhone = 'getClientByPhone',
  getAllHotelCategories = 'getAllHotelCategories', // TODO: DELETE
  getAllMappedHotelCategories = 'getAllMappedHotelCategories', // TODO: DELETE
  getAllHotelImageTags = 'getAllHotelImageTags', // TODO: DELETE
  getAllHotelSuppliers = 'getAllHotelSuppliers', // TODO: DELETE
  getAllHotelExtractorSuppliers = 'getAllHotelExtractorSuppliers', // TODO: DELETE
  getAllHotels = 'getAllHotels', // TODO: DELETE
  getHotelPropertyFares = 'getHotelPropertyFares',
  getAllTeams = 'getAllTeams',
  getTeamsByTokensAgencies = 'getTeamsByTokensAgencies',
  getAllUsers = 'getAllUsers',
  getAllWorkflows = 'getAllWorkflows',
  getAmenititesBySupplier = 'getAmenititesBySupplier',
  getAllAmenitites = 'getAllAmenitites',
  getAllMappedAmenitites = 'getAllMappedAmenitites',
  getCategoriesBySupplier = 'getCategoriesBySupplier',
  getCaseHandlers = 'getCaseHandlers',
  getBookingById = 'getBookingById',
  getCalls = 'getCalls',
  getCaseById = 'getCaseById',
  getCaseHistory = 'getCaseHistory',
  getEmailThread = 'getEmailThread',
  getCaseSaleOrders = 'getCaseSaleOrders',
  getClientById = 'getClientById',
  getDefaultProviders = 'getDefaultProviders',
  getHotelData = 'getHotelData', // TODO: DELETE
  getHotelCardData = 'getHotelCardData', // TODO: DELETE
  getHotelRating = 'getHotelRating', // TODO: DELETE
  getHotelDupesTentative = 'getHotelDupesTentative', // TODO: DELETE
  getHotelImageTagById = 'getHotelImageTagById', // TODO: DELETE
  getHotelModeratedBy = 'getHotelModeratedBy', // TODO: DELETE
  getItineraryByBookingId = 'getItineraryByBookingId',
  getItineraryById = 'getItineraryById',
  getAgencyIVR = 'getAgencyIVR',
  getMyUserData = 'getMyUserData',
  getMyUserAgencies = 'getMyUserAgencies',
  getRelatedCases = 'getRelatedCases',
  getSettingsByAgencyId = 'getSettingsByAgencyId',
  getStepsByManyWorkflowIds = 'getStepsByManyWorkflowIds',
  getTeamById = 'getTeamById',
  getUserAvailability = 'getUserAvailability',
  getUserById = 'getUserById',
  getUsersByAgency = 'getUsersByAgency',
  getUsersByTokensAgency = 'getUsersByTokensAgency',
  getUsersByTeam = 'getUsersByTeam',
  getUsersByOrganization = 'getUsersByOrganization',
  getWorkflowById = 'getWorkflowById',
  getWorkflowsForCase = 'getWorkflowsForCase',
  getWorkflowSteps = 'getWorkflowSteps',
  postBookFare = 'postBookFare',
  postConfirmFare = 'postConfirmFare',
  updateStep = 'updateStep',
  updateWorkflow = 'updateWorkflow',
  getStepConnections = 'getStepConnections',
  getFeatureFlags = 'getFeatureFlags',
  getSupportFormsByAgency = 'getSupportFormsByAgency',
  getSupportFormById = 'getSupportFormById',
  getWhatsappMessages = 'getWhatsappMessages',
  getWhatsappClientMessages = 'getWhatsappClientMessages',
  getOrganizationsByAgencyId = 'getOrganizationsByAgencyId',
  getOrganizationById = 'getOrganizationById',
  getNotifications = 'getNotifications',
  getCaseSavedFilters = 'getCaseSavedFilters',
  getUserAgencies = 'getUserAgencies',
  getHotelFares = 'getHotelFares',
  getFieldBlocks = 'getFieldBlocks',
  getFieldBlockById = 'getFieldBlockById',
  getFieldBlockByWorkflowId = 'getFieldBlockByWorkflowId',
  getFieldBlockByWorkflowIds = 'getFieldBlockByWorkflowIds',
  getCaseCustomFields = 'getCaseCustomFields',
  getMarkupRulesByAgencyId = 'getMarkupRulesByAgencyId',
  saleOrder = 'saleOrder',
  flightIntegrations = 'flightIntegrations',
  getHotelContentAutoComplete = 'getHotelContentAutoComplete',
  gupshupSubscriptions = 'gupshupSubscriptions',
  gupshupTemplates = 'gupshupTemplates',
  getWhatsappQuickReplies = 'getWhatsappQuickReplies',
  gupshupActiveConversations = 'gupshupActiveConversations',
  getSaleOrdersForDashboard = 'getSaleOrdersForDashboard',
  getSaleOrdersDetails = 'getSaleOrdersDetails',
  getSaleOrdersPaxes = 'getSaleOrdersPaxes',
  getSaleOrdersItems = 'getSaleOrdersItems',
  getInvalidationRuleById = 'getInvalidationRuleById',
  getCasesStatsByDay = 'getCasesStatsByDay',
  getCasesStatsByTeam = 'getCasesStatsByTeam',
  getCasesStatsByStatus = 'getCasesStatsByStatus',
  getCasesStatsByWorkflow = 'getCasesStatsByWorkflow',
  getCasesStatistics = 'getCasesStatistics',
  getNeedAgentStats = 'getNeedAgentStats',
  getCasesByPeriods = 'getCasesByPeriods',
  getCasesResolvedByPeriods = 'getCasesResolvedByPeriods',
  getCasesNeedAgentByTimeOpen = 'getCasesNeedAgentByTimeOpen',
  getCasesByDayOfWeek = 'getCasesByDayOfWeek',
  getCasesByDayAndHour = 'getCasesByDayAndHour',
  getImportantNumbers = 'getImportantNumbers',
  getAvailableCountries = 'getAvailableCountries',
  getAgents = 'getAgents',
  getAgentsStatusSummary = 'getAgentsStatusSummary',
  getPaginatedClientUploads = 'getPaginatedClientUploads',
  getPaginatedCaseUploads = 'getPaginatedCaseUploads',
  getModeratedHotelsAmenities = 'getModeratedHotelsAmenities',
  getModeratedHotelsMedias = 'getModeratedHotelsMedias',
  getModeratedHotelsCheckOptions = 'getModeratedHotelsCheckOptions',
  getModeratedHotelsDescriptions = 'getModeratedHotelsDescriptions',
  getAllFlightIntegrations = 'getAllFlightIntegrations',
  getAFlightIntegrationById = 'getAFlightIntegrationById',
  getAllAgencyFlightIntegrations = 'getAllAgencyFlightIntegrations',
  getAllHotelIntegrations = 'getAllHotelIntegrations',
  getAHotelIntegrationById = 'getAHotelIntegrationById',
  getUserNotificationTriggers = 'getUserNotificationTriggers',
  getUserNotificationTriggerCapabilities = 'getUserNotificationTriggerCapabilities',
  createUserNotificationTrigger = 'createUserNotificationTrigger',
  getIAConfigByAgencyId = 'getIAConfigByAgencyId',

  // CONTENT EXTRACTOR
  getHotelVendorHotels = 'getHotelVendorHotels',
  getHotelSuppliers = 'getHotelSuppliers',
  getHotelDestinations = 'getHotelDestinations',
  getHotelBoards = 'getHotelBoards',
  getHotelCategories = 'getHotelCategories',
  getHotelNimbuxHotels = 'getHotelNimbuxHotels',
  getHotelVendorHotelById = 'getHotelVendorHotelById',
  getHotelNimbuxHotelById = 'getHotelNimbuxHotelById',
  getNimbuxHotelImages = 'getNimbuxHotelImages',
  getModeratedVendorHotelsById = 'getModeratedVendorHotelsById',
  getHotelAmenities = 'getHotelAmenities',
  getVendorHotelDescriptions = 'getVendorHotelDescriptions',
  getCaseTriggers = 'getCaseTriggers',
  getWebhooks = 'getWebhooks',
  getMetaCapiConfig = 'getMetaCapiConfig',
}

export type FlightsRequestQueryParams = FlightSearchForm;

export type FlightSearchForm = {
  origin: string;
  destination: string;
  initialDate: string;
  endDate?: string;
  guests?: number;
  adults?: number;
  children?: number;
  infants?: number;
};

type roomInfo = {
  adults: number;
  kids?: number;
  babies?: number;
};

export type IHotelSearch = {
  destination: string;
  initialDate?: string;
  endDate?: string;
  rooms: roomInfo[];
};

export interface ControlledFieldProp {
  formFieldName: string;
  text: string;
  error?: string;
  icon?: ReactNode;
}

export interface SortingOptions {
  sort: string;
  order: OrderOptionsValues;
}

// TODO: Consumir desde shared en lo posible, hay un dto pero
// no parece ser compatible con el FE.
export type FlightsRequestPayload = {
  arrival: string;
  dateFrom: string;
  departure: string;
  dateTo?: string;
  adults?: number;
  children?: number;
  infants?: number;
};

export interface OptionType {
  label: string;
  value: string;
}
